import {
  DEFAULT_API_URL,
  customFetch,
  ExtendedFetchOptions,
  transformParamsToString,
  FetchParams,
  ErrorMessage,
  APIError,
} from '../../common';

export const getBannerPreview = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: ContentApi.BannerPreviewFetchOptions & FetchParams;
}): Promise<ContentApi.BannerResponse> => {
  const {
    language,
    marketplace,
    channelId,
    bannerId,
    resource,
    callerId,
    token,
    fetchParams: { timeout = 1000, baseUrl = DEFAULT_API_URL } = {},
  } = params;
  const paramsString = transformParamsToString({
    channelId,
    language,
    marketplace,
  });

  const options: ExtendedFetchOptions['options'] = {
    headers: {
      Authorization: `Bearer ${token}`,
      'nike-api-caller-id': callerId,
    },
    method: 'GET',
    timeout,
  };
  const url = `${baseUrl}/content/previewproxy/v1/banner/${bannerId}${paramsString}`;

  const result = await customFetch({
    fetchFn,
    options,
    resource,
    url,
  });

  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.messsage,
      requestOptions: options,
      url,
    });
  }
};
